import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { ListViewComponent } from "./list-view/list-view.component";
import { SideMenuComponent } from "./side-menu/side-menu.component";
import { OrderBoardComponent } from "./order-board/order-board.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { KanbanViewComponent } from "./kanban-view/kanban-view.component";
import { HomeComponent } from "./home/home.component";
import { PerfilComponent } from "./perfil/perfil.component";
import { EntregasComponent } from "./entregas/entregas.component";
import { ConfigComponent } from "./config/config.component";
import { AppRoutingModule } from "./app-routing.module";
import { FormaEntregaPipe } from "./pipes/forma-entrega.pipe";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalPedidoComponent } from "./modal-pedido/modal-pedido.component";
import { MatDialogModule } from "@angular/material/dialog";
import { SafeUrlPipe } from "./pipes/safe-url.pipe";
import { ModalLoginComponent } from "./modal-login/modal-login.component";
import { AuthService } from "./services/auth.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { NavComponent } from "./componentes/navbar/nav/nav.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MatFilterItemDirective } from "./diretivas/mat-filter-item.directive";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { OrdernarPedidosPipe } from "./pipes/ordernar-pedidos.pipe";
import { ColorProgressPipe } from "./pipes/color-progress.pipe";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { FiltroExibicaoPedidoPipe } from "./pipes/filtro-exibicao-pedido.pipe";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { ModalUserConfigComponent } from "./modal-user-config/modal-user-config.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ConfirmComponent } from "./componentes/dialog/confirm/confirm.component";
import { AcaoAvancarPedidoPipe } from "./pipes/acao-avancar-pedido.pipe";
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LongPressDirective } from './diretivas/longpress.directive';
import { ImpressaoComponent } from './impressao/impressao.component';
import { MatSliderModule } from '@angular/material/slider';
import { EventService } from "./services/event.service";
import { BotaoFiltroPedidoComponent } from './componentes/botao-filtro-pedido/botao-filtro-pedido.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  declarations: [
    AppComponent,
    ListViewComponent,
    SideMenuComponent,
    OrderBoardComponent,
    KanbanViewComponent,
    HomeComponent,
    PerfilComponent,
    EntregasComponent,
    ConfigComponent,
    FormaEntregaPipe,
    ModalPedidoComponent,
    SafeUrlPipe,
    ModalLoginComponent,
    NavComponent,
    MatFilterItemDirective,
    OrdernarPedidosPipe,
    ColorProgressPipe,
    SafeHtmlPipe,
    FiltroExibicaoPedidoPipe,
    ModalUserConfigComponent,
    ConfirmComponent,
    AcaoAvancarPedidoPipe,
    LongPressDirective,
    ImpressaoComponent,
    BotaoFiltroPedidoComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatSlideToggleModule,
    MatDialogModule,
    DragDropModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    MatMenuModule,
    MatIconModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    MatButtonModule,
    MatCardModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatSliderModule,
    ScrollingModule
  ],
  providers: [AuthService, SafeUrlPipe],
  bootstrap: [AppComponent],
})
export class AppModule { }
